<app-uni-page  [parent]="this" pageTitle="Back Orders for Account: {{ getTitle() }}"
  [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate">
</app-uni-page>

<ng-template #bodyTemplate>
  <app-ag-grid *ngIf="isPageReady" [gridOptions]="podGridOptions" [rowData]="podItems" ></app-ag-grid>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>